import React, { useContext } from "react";
import {
  Backdrop,
  CircularProgress,
  makeStyles,
  Box,
  Typography,
} from "@material-ui/core";
import LayoutContext from "../../context/layout/LayoutContext";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

export default () => {
  const classes = useStyles();

  const { loading, progress } = useContext(LayoutContext);

  return (
    loading && (
      <Backdrop className={classes.backdrop} open={loading}>
        {" "}
        {/* <CircularProgress
                          variant="indeterminate"
                          color="secondary"
                          size={90}
                          thickness={2}
                        /> */}{" "}
        <Box position="relative" display="inline-flex">
          <CircularProgress
            variant="indeterminate"
            color="secondary"
            size={90}
            thickness={3}
          />{" "}
          {progress || parseFloat(progress) === 0 ? (
            <Box
              top={0}
              left={0}
              bottom={0}
              right={0}
              position="absolute"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Typography
                variant="caption"
                color="secondary"
                style={{
                  fontSize: 15,
                }}
              >
                {`${Math.round(parseFloat(progress))}%`}{" "}
              </Typography>{" "}
            </Box>
          ) : null}{" "}
        </Box>{" "}
      </Backdrop>
    )
  );
};
